export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: 'a44c1fca-3209-4941-b54c-bcd8b30e414c',

  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'com',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'experienciabancaprivada.vivofacil',

  /**
  * Nombre de la app
  */
  appName: 'Experiencia Banca Privada',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Vivofácil',

  /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'vivofacil',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-MDRV5E57TD',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: true,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false,

  /** numero de telefono o false. Si es false no se muestra el icono de whatsapp en las páginas */
  whatsapp: false,

  /** true of false. Define si se muestra el botón para volver al inicio */
  homeButton: true,

  /** true o false. Define si se muestra el area privada */
  showPrivateArea: true,

  /** Se permiten contraseñas no seguras */
  allowInsecurePasswords: false,

  /**
   * Api Key de Google Maps
   * Valores: false|<clave_publica>
   */
  googleMapsApiKey: 'AIzaSyAnoowlhGOt23DWy0YI7j5R7tbBCrCqYs0',

  /** true o false. Define si se activa DragonPass */
  dragonpassEnabled: true,

  /**
   * Datos eSIM para descontar stock
   *    min: número de días mínimo del rango
   *    max: número de días máximo del rango
   *    value: stock a descontar
   */
  esimRanges: [
    {min: 1, max: 7, value: 1},
    {min: 8, max: 14, value: 2},
    {min: 15, max: 21, value: 3},
    {min: 22, max: 28, value: 4}
  ],

  documentTypes: [1, 3],
  validateDocumentType: true,

  defaultCountryCode: 'ES',
  defaultCountryName: 'España',

  additionalRegisterFields: {
    telephone: {
      required: true
    },
    zipCode: {
      required: true
    },
    gender: {
      required: true
    },
    birthDate: {
      required: true
    }
  },

  showPublicContactChannels: false,
  contactFormPublicUuid: 'f463c6cf-ec8d-4b13-adb8-2e4fc857cfca',

  /** testamentis */
  testamentisHereditary: 'https://formularios.alares.local/form/create/1edaeaf3-6bc3-651c-ae2c-1b9a90d4d278/embed',
  testamentisLiving: 'https://formularios.alares.local/form/create/1ed08dea-bf79-6442-8808-436f6414e40d/embed'
};
